import React from "react";
import BaseComponent from "../BaseComponent";
import Input from "../Input";
import Dropdown from "../Dropdown";
import Button from "../Button";
import { Constant } from '../../const';
import ModuleNodeModel from "../../models/ModuleNodeModel";
import ObjectUsedIn from "../../utilities/usedIn/ObjectsUsedIn";

export default class CustomHeaderSubCon extends BaseComponent {
    /**
     * Submenu view for custom http headers
     * @module CustomHeaderSubCon
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            argumentName: props.data ? props.data.variable.argumentName : null,
            value: props.data ? props.data.variable.value : null,
            varName: props.data ? props.data.variable.varName: null,
            type: props.data ? props.data.variable.type : "value"
        }
        this.varModel = this.isKnownModel() ? this.props.data.variable : this.initVarModel();
        this.varError = '';
        this.varIdx = (this.props.data && this.props.data.varIdx) ? this.props.data.varIdx : 0;
        this.nodetypename = this.props.context.props.context.props.nodeTypeName ? this.props.context.props.context.props.nodeTypeName : "";
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initVarModel() {
        return {
            argumentName: null,
            type: "value",
            value: null,
            varName: null,
            id: null,
            sensitiveData: false,

        };
    }

    /**
     * Set config proxy; catches own input value updates and update its data model before saving to list
     * @param {string} key
     * @param {string|boolean} value
     */
    // here is where we should change state
    setConfig(key, value) {

        if(key === 'varName'){
            const checkVariable = this.isValidVariable(value);

            if(checkVariable.isValidVar) {
                this.varModel.id = checkVariable.varId;
            } else {
                return;
            } 
        }

        if (this.props.context.props.context instanceof ModuleNodeModel) {
            document.dispatchEvent(new CustomEvent("ev-property-refresh"));
        }

        this.varModel[key] = value;

        if(key === "type" && value === "variable"){
            this.varModel["value"] = null;
            this.setState({[key] : value, value: null});
        }

        if(key === "type" && value === "value"){
            this.varModel["varName"] = null;
            this.setState({[key] : value, varName: null});
        }

        this.setState({[key] : value});
        
    }
    /**
    * Get config proxy
    * @param {string} key
    * @returns {string}
    */
    getConfig(key) {
        return this.varModel[key];
    }

    /**
     * Returns if is valid variable, prevents user typing in non-existing variable names
     * @returns Boolean
     */
    isValidVariable(variable) {

        // Define toast error strings
        const varNotFound = "Variable "+variable+" not found";
        const varSensitive = "Custom HTTP Headers cannot contain variables marked with Sensitive data";
        
        const splitVarName = variable.split(".");
        const checkVariable = {};
        // if variable not found then this will always be false
        checkVariable['isValidVar'] = false;
        this.varError = varNotFound;

        // application variables
        if (splitVarName[0] === Constant.k.SCOPE_APPLICATION && window.apm.getVariable(splitVarName[1])) {
            var appVariable = window.apm.getVariable(splitVarName[1]);
            checkVariable['varId'] = appVariable.id;

            if(!appVariable.props.config.sensitiveData){
                checkVariable['isValidVar'] = true;
                this.varError = '';
            } else {
                this.varError = varSensitive;
            }
        }

        // local variables
        if (splitVarName[0] === Constant.k.SCOPE_MODULE) {
            if (this.props.context.props.context && this.props.context.props.context.props.context) {
                const nodeUsedIn = ObjectUsedIn.getObjectUsedIn(this.props.context.props.context.props.context.props.parentComponentID, window.apm.serialized);
                
                if (nodeUsedIn[0].length > 0) {
                    nodeUsedIn[0].forEach(m => {
                        const module = window.apm.serialized.components.modules.find(mo => mo.id === m);
                        
                        if (module) {
                            const node = module.versions[1].flow.nodes.find(n => n.props.parentComponentID === this.props.context.props.context.props.context.props.parentComponentID)

                            if (node) {
                                var modVariable = window.apm.getVariable(splitVarName[1], module.id);
                                checkVariable['varId'] = modVariable.id;

                                if(!modVariable.props.config.sensitiveData){
                                    checkVariable['isValidVar'] = true;
                                    this.varError = '';
                                } else {
                                    this.varError = varSensitive;
                                }
                            }
                        }
                    });
                }
            }

            else if (this.props.context.props.context && this.props.context.props.context.id) {
                const componentUsedIn = ObjectUsedIn.getObjectUsedIn(this.props.context.props.context.props.parentComponentID, window.apm.serialized);
                if (componentUsedIn[0].length > 0) {
                    componentUsedIn[0].forEach(m => {
                        const module = window.apm.serialized.components.modules.find(mo => mo.id === m);
                        
                        if (module) {
                            const node = module.versions[1].flow.nodes.find(n => n.props.parentComponentID === this.props.context.props.context.props.parentComponentID)

                            if (node) {
                                var modVariable = window.apm.getVariable(splitVarName[1], module.id);
                                
                                if (modVariable) {
                                    checkVariable['varId'] = modVariable.id;
                                    
                                    if(!modVariable.props.config.sensitiveData){
                                        checkVariable['isValidVar'] = true;
                                        this.varError = '';
                                    } else {
                                        this.varError = varSensitive;
                                    }
                                }

                            }
                        }
                    });
                }

            }
        }

        return checkVariable;
    }

    /**
     * Returns true if model has argumentName and value or variable based on type
     * @returns boolean
     */
    isValidModel() {
        // replace varModel refs with equivelent state refs (this.state.type, etc)
        const hasArgumentName = this.varModel.argumentName !== null;
        const isValidValue = this.varModel.type === 'value' && this.varModel.value !== null;
        const isValidVariable = this.varModel.type === 'variable' && !this.varError; 

       return hasArgumentName && (isValidValue || isValidVariable);
    }

    isKnownModel() {
        return this.props.data && this.props.data.variable;
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const preSelection = window.apm.knowledgeBase.getNodeInputTypeIndexFromValue(this.varModel.type);

        return (
            <div>
                <Input
                    label={"Header name"}
                    hint={"Header-Name"}
                    valRules={{ "noEmpty": true, "headerName": true }}
                    value={this.state.argumentName}
                    context={this}
                    valKey={"argumentName"}
                    disabled={this.props.context.props.readOnly}
                    suppressUpdate={true}
                />
                <Dropdown
                    wide={true}
                    label={"Get header value from"}
                    optionName={this.getPropLabel("type_opt")}
                    options={window.apm.knowledgeBase.getNodeInputTypes()}
                    context={this}
                    valKey={"type"}
                    selection={preSelection}
                    readOnly={this.props.context.props.readOnly}
                    suppressUpdate={true}
                />
                {this.state.type === "value" &&
                    <Input
                        label={"Header value"}
                        hint={"Header value"}
                        context={this}
                        valKey={"value"}
                        value={this.state.value}
                        disabled={this.props.context.props.readOnly}
                        suppressUpdate={true}
                    />
                }

                {this.state.type === "variable" &&
                    <Input
                        label={this.getPropLabel("scoped_variable_name")}
                        hint={this.getPropLabel("scoped_variable_name_hint")}
                        context={this}
                        valKey={"varName"}
                        value={this.state.varName}
                        suggestion={"variable"}
                        excludeSensitiveVariables={true}
                        tooltip={'Non-sensitive Variables Only'}
                        disabled={this.props.context.props.readOnly}
                        suppressUpdate={true}
                    />
                }

                {(() => {
                    if (this.props.context.props.readOnly) {
                        return <label>{this.getPropLabel("read_only")}</label>;

                    }
                    if (this.isKnownModel()) {
                        // Display edit and delete for editing
                        return (
                            <div style={{ width: "100%", display: "flex", justifyContent: "space-around" }}>
                                <div>
                                    <Button
                                        icon={"icon-trash"}
                                        tint={"warning"}
                                        callback={() => {
                                            this.props.context.remove(this.varIdx);
                                            this.props.domContext.removeSubmenu();
                                        }}
                                    />
                                </div>
                                <div>
                                    <Button
                                        label="Save"
                                        wide={true}
                                        callback={() => {
                                            if (this.isValidModel()) {
                                                this.props.context.update(this.varModel, this.varIdx);
                                            } else {
                                                window.apm.notification.post("error", this.varError, true);
                                            }
                                            this.props.domContext.removeSubmenu();
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    }

                    return (
                        <Button label="Add" wide={true}
                            callback={() => {
                                if (this.isValidModel()) {
                                    // Add current data model to item list
                                    this.props.context.add(this.varModel);
                                } else {
                                    window.apm.notification.post("error", this.varError, true);
                                }
                                this.props.domContext.removeSubmenu();
                            }}
                        />
                    );
                })()}
            </div>
        );
    }
}
